import * as React from 'react';
import Price, { usePrice } from './Price';
import * as Styled from './Hero.styles';
import CTAButton, { useCTAButtonTracking } from '@ids/pages/landing/CTAButton';
import { useHeroBlock } from '@ids/context/LandingPage';
import Skeleton from '@ids/components/Layout/Skeleton';
import { IDSContentfulMedia } from '@ids/types/contentful';

const useMobileMediaAspectRatio = (media?: IDSContentfulMedia) => {
    const defaultAspectRatio = 4 / 3;

    if (media?.video) {
        return media.video.aspectRatio ?? defaultAspectRatio;
    }

    if (media?.image) {
        return media.image.file.details.image.width / media.image.file.details.image.height ?? defaultAspectRatio;
    }

    return defaultAspectRatio;
};

const Hero = () => {
    const heroBlock = useHeroBlock();
    const trackCTAButtonClick = useCTAButtonTracking();
    const mobileMediaAspectRatio = useMobileMediaAspectRatio(heroBlock?.images.mobile);
    const price = usePrice();

    if (!heroBlock) {
        return <Skeleton />;
    }

    return (
        <Styled.HeroSection data-testid="hero-block-section" id="hero-block">
            <Styled.MediaWrapper $backgroundColor={heroBlock.textBackgroundColor} ratio={mobileMediaAspectRatio}>
                <Styled.Media
                    priority
                    images={[heroBlock.images.mobile, heroBlock.images.desktop]}
                    data-testid="hero-image"
                    useMediaQuerySources
                />
            </Styled.MediaWrapper>
            <Styled.TextWrapper $backgroundColor={heroBlock.textBackgroundColor} $color={heroBlock.textColor}>
                <Styled.Title as="h1">{heroBlock.title}</Styled.Title>
                <Price data-testid="hero-block-price">{price}</Price>
                <CTAButton data-testid="hero-cta-button" onClick={() => trackCTAButtonClick('ga_hero_cta')}>
                    {heroBlock.ctaText}
                </CTAButton>
            </Styled.TextWrapper>
        </Styled.HeroSection>
    );
};

export default Hero;
